import React from 'react';
import { RadioGroup } from '@headlessui/react';
import cx from 'classnames';

import { BackendPublicEnums } from 'public-api/codegen';
import ProductCard from 'ui-brand/components/ProductCard';

type SelectedProducts = BackendPublicEnums.SelectedProductsEnum[];

const BOTH = 'BOTH';

type Choice = BackendPublicEnums.SelectedProductsEnum | typeof BOTH;

const PRODUCTS = [
  {
    value: BackendPublicEnums.SelectedProductsEnum.MANAGER,
    title: 'Retino Returns',
    tagline: gettext('Returns and claims on autopilot'),
  },
  {
    value: BackendPublicEnums.SelectedProductsEnum.TRACKING,
    title: 'Retino Tracking',
    tagline: gettext('No more "Where is my package?" questions'),
  },
];

const toChoice = (value: SelectedProducts): Choice | null => {
  if (PRODUCTS.every((product) => value.includes(product.value))) return BOTH;
  return value[0] ?? null;
};

const fromChoice = (choice: Choice): SelectedProducts =>
  choice === BOTH ? PRODUCTS.map((product) => product.value) : [choice];

type Props = {
  stacked?: boolean;
  disabled?: boolean;
  value: SelectedProducts;
  onChange: (value: SelectedProducts) => void;
};

function ProductSelection({ stacked = false, disabled = false, value, onChange }: Props) {
  return (
    <RadioGroup
      value={toChoice(value)}
      onChange={(choice: Choice) => onChange(fromChoice(choice))}
      disabled={disabled}
      aria-label={gettext('Products')}
    >
      <div className={cx('grid gap-4', !stacked && 'lg:grid-cols-2')}>
        {PRODUCTS.map((product) => (
          <ProductCard
            key={product.value}
            value={product.value}
            compact={stacked}
            title={product.title}
            tagline={product.tagline}
          />
        ))}
      </div>
      <div className="mt-4">
        <ProductCard
          value={BOTH}
          compact={stacked}
          title={gettext('I want both products')}
          badge={gettext('recommended')}
        />
      </div>
    </RadioGroup>
  );
}

export default ProductSelection;
